module.exports = __webpack_public_path__ + "img/blue.a6a03e01.svg";